import { Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Acesso } from '../../models/bas/acesso';
import { CadastroGenerico } from '../../models/generics/cadastro-generico';
import { ParametrosGenericos } from '../../models/generics/parametros-genericos';
import { AcessoService } from '../../services/bas/acesso.service';
import { AuthService } from '../../services/auth.service';
import { CustomSnackBarService } from '../../services/custom-snack-bar.service';
import { LoaderService } from '../../services/loader.service';
import { RelacaoGenericaService } from '../../services/generics/relacao-generica.service';
import { TrataExcessaoService } from '../../services/trata-excessao.service';
import { Subject } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-abstract-idba-component',
  template: ``,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [],
})
export class GenericIdbaComponent implements OnInit, OnDestroy {
  public programa: string;
  public acesso: Acesso | undefined = undefined;
  public form: UntypedFormGroup;
  public destroy$ = new Subject<void>();
  public funcoes: any = {};
  public parametrosGenericos: ParametrosGenericos[] = [];
  public cadastrosGenericos: CadastroGenerico[] = [];
  public assuntosRelacoesGenericas: string[] = [];

  public relacaoGenericaService = inject(RelacaoGenericaService);
  public snackBar = inject(CustomSnackBarService);
  public authService = inject(AuthService);
  public acessoService = inject(AcessoService);
  public loaderService = inject(LoaderService);

  constructor() {
    this.acessoService.resetModel();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit() {
    this.consultaPermissaoAcesso();
  }

  public getGenericParams() {
    if (this.assuntosRelacoesGenericas && this.assuntosRelacoesGenericas.length > 0) {
      this.relacaoGenericaService.getRelacaoGenericaBySubjectList(this.assuntosRelacoesGenericas).then(() => {
        this.applyFunctions();
      });
    } else {
      this.applyFunctions();
    }
  }

  applyFunctions(): void {

  }

  public consultaPermissaoAcesso() { };

  public showMessage(msg: string, type: string = 'Success') {
    this.snackBar.openSnackBar(msg, null, type);
  }

  public verificaSeleciona(event, campo: string, campoCodigo: string) {
    if (event.srcElement.value === '') {
      this.form.controls[campo].setValue('');
      this.form.controls[campoCodigo].setValue(null);
    }
  }

  formatCurrencyToNumber(preco): number {
    if (typeof preco === 'string' || preco instanceof String) {
      preco = preco.replace("R$ ", "");
      preco = preco.replaceAll(".", "")
      preco = preco.replace(",", ".")
    }
    return parseFloat(preco)
  }

  public trataErro(err) {
    TrataExcessaoService.TrataExcessao(err, this.authService, this.snackBar);
  }

  formatNumberToCurrency(preco) {
    if (preco && (preco.toString().includes(".") || preco.toString().includes(",")) && !(preco.toString().includes(".") && preco.toString().includes(","))) {
      preco = preco.toString()
      const lastIndex = preco.lastIndexOf('.');

      const replacement = ',';

      preco =
        preco.substring(0, lastIndex) +
        replacement +
        preco.substring(lastIndex + 1);
      if (preco.substring(0, 1) === ",") {
        preco = preco.substring(1)
      }
    }
    return preco
  }

  pesquisaParamatroRelacaoLogico(assunto: string, nomeParametro: string, valorDefault: boolean) {
    var indAux = this.authService.getParametroRelacao(assunto, nomeParametro);
    if (indAux)
      return JSON.parse(indAux);
    else return valorDefault;
  }

  pesquisaParamatroRelacaoString(assunto: string, nomeParametro: string, valorDefault: string) {
    var aux = this.authService.getParametroRelacao(assunto, nomeParametro);
    if (aux) {
      return JSON.parse(aux).toString();
    }
    else return valorDefault;

  }

  public returnSelf() {
    return this;
  }

  protected isObjectEmpty(obj: object): boolean {
    return obj === undefined || (obj && Object.keys(obj).length === 0);
  };

}


